import React from 'react';
import { Image, Text, View } from 'react-native-web';
import { Android, kbd_announcement_icon } from '../../../../utils/DictionaryManagementUtils';
import {
  getImageByKey,
  img_scr_onboarding_01_and,
  img_scr_onboarding_01_ios,
} from '../../../../utils/ImagesManagementUtils';
import { getMediumFont, getRef } from '../../../../utils/Utils';
import FullPageSpecialSimulator from '../FullPageSpecialSimulator';
import { textLink_9_3 } from '../../AuxiliaryComponent/TextComponent/TextStyle';

const AnnouncementFP = ({
  globJSON,
  simPlatform,
  slideshowRefs = null,
}) => {
  const { colors } = globJSON.configurations.theme;
  const { announcement } = globJSON.configurations.onboarding;
  const img1 = getImageByKey(announcement.kbd_announcement_icon, kbd_announcement_icon);

  const myStyles = {
    BottomPageStyle: {
      width: 240,
      height: simPlatform === Android ? 221 : 264,
      marginTop: simPlatform === Android ? 206 : 256,
      borderTopLeftRadius: 5.8,
      borderTopRightRadius: 5.8,
      backgroundColor: colors.app_background_color,
    },
    CircleContainer: {
      width: 96,
      height: 96,
      marginTop: simPlatform === Android ? 158 : 208,
      alignSelf: 'center',
      position: 'absolute',
      borderRadius: 48,
      backgroundColor: colors.app_background_color,
    },
    imageStyle: {
      alignSelf: 'center',
      marginTop: simPlatform === Android ? 177 : 217,
      width: 50,
      height: 58,
      position: 'absolute',
    },
    linkStyle: {
      marginTop: simPlatform === Android ? 305 : 417, position: 'absolute', alignSelf: 'center',
    },
    greyPage: {
      width: 240,
      height: simPlatform === Android ? 427 : 520,
      marginTop: 0,
      marginLeft: 0,
      position: 'absolute',
      backgroundColor: '#fff',
      opacity: 0.5,
    },
    lblPrivacyPolicy: {
      width: 186,
      height: 14,
      marginLeft: 27,
      marginTop: simPlatform === Android ? 310 : 407,
      fontFamily: `${getMediumFont(globJSON, simPlatform, true)}`,
      fontSize: 9.3,
      textAlign: 'center',
      color: colors.links_icons_color,
      position: 'absolute',
    },
  };

  return (
    <View ref={getRef(slideshowRefs)}>
      <FullPageSpecialSimulator
        globJSON={globJSON}
        simPlatform={simPlatform}
        WithImageBackground={simPlatform === Android ? img_scr_onboarding_01_and : img_scr_onboarding_01_ios}
        LabelInputText={announcement.o_a_title}
        numOfPointThatGetColor={1}
      >
        <View style={myStyles.BottomPageStyle} />
        <View style={myStyles.CircleContainer} />

        <Image
          fadeDuration={0}
          resizeMode="contain"
          style={myStyles.imageStyle}
          source={img1}
        />

        {announcement.enable_keyboard_privacy_link && (
        <Text style={[textLink_9_3(globJSON, simPlatform), myStyles.linkStyle]}>
          {announcement.o_a_privacy_policy}
        </Text>
        )}
      </FullPageSpecialSimulator>
      {!announcement.enable_keyboard_activation_flow && <View style={myStyles.greyPage} />}
    </View>
  );
};

export default AnnouncementFP;
